<template>
  <tr>
    <td>{{ venta.fecha_de_venta }}</td>
    <td>${{ dotsCadaTres(parseFloat(venta.precio_total).toFixed(2).replace(/\.00$/, '')) }}</td>
    <td>{{ venta.persona.nombre }} {{ venta.persona.apellido }}</td>
    <td>{{ venta.estado.nombre }}</td>
  </tr>
</template>

<script>
// import ServiciosListaItemCuota from '../components/ServiciosListaItemCuota.vue'
// import serviciossService from '../services/servicios'
export default {
  name: 'VentasListaCarrito2Item',
  components: {
  },
  props: ['venta'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>
